import { ref } from 'vue'

interface ToastOptions {
  type: 'success' | 'error' | 'warning' | 'info'
  message: string
  duration?: number
}

const toasts = ref<Array<ToastOptions & { id: string }>>([])

export function useToast() {
  const showToast = (options: ToastOptions) => {
    const id = Math.random().toString(36).substr(2, 9)
    const toast = { ...options, id }

    toasts.value.push(toast)

    // Auto remove after duration
    const duration = options.duration || 5000

    setTimeout(() => {
      removeToast(id)
    }, duration)

    return id
  }

  const removeToast = (id: string) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1)
      toasts.value.splice(index, 1)
  }

  const clearAllToasts = () => {
    toasts.value = []
  }

  return {
    toasts: toasts.value,
    showToast,
    removeToast,
    clearAllToasts,
  }
}
